import React from 'react';
import {connect} from 'react-redux';
import {Link as RouterLink} from 'react-router-dom';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import {makeStyles} from '@material-ui/styles';
import {Avatar, Typography} from '@material-ui/core';

const useStyles = makeStyles(theme => ({
   root: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      minHeight: 'fit-content'
   },
   avatar: {
      width: 60,
      height: 60,
      color: theme.palette.getContrastText(theme.palette.primary.main),
      backgroundColor: theme.palette.primary.main
   },
   name: {
      marginTop: theme.spacing(1),
      wordBreak: 'break-word',
      overflowWrap: 'break-word',
      whiteSpace: 'normal',
      width: '100%',
      minWidth: 0,
      textAlign: 'center'
   }
}));

function Profile({ className, usuario, ...rest }) {
   const classes = useStyles();

   return (
      <div {...rest} className={clsx(classes.root, className)}>
         {usuario.avatar ? (
            <Avatar
               alt="Person"
               className={classes.avatar}
               component={RouterLink}
               src={usuario.avatar}
               to="/home" />
         ) : (
            <Avatar alt="Person" className={classes.avatar} component={RouterLink} to="/home">
               {usuario.tipoDoc === '6'
                  ? usuario.razonSocial.substring(0, 1)
                  : `${usuario.nombre.substring(0, 1)}${usuario.apPaterno.substring(0, 1)}`}
            </Avatar>
         )}
         <Typography className={classes.name} variant="h4">
            {usuario.tipoDoc === '6'
               ? usuario.razonSocial
               : `${usuario.nombre} ${usuario.apPaterno}`}
         </Typography>
         <Typography variant="body2">{usuario.nroDoc}</Typography>
      </div>
   );
}

Profile.propTypes = {
   className: PropTypes.string
};

function mapStateToProps(state) {
   return {
      usuario: state.auth.usuario
   };
}

function mapDispatchToProps(dispatch) {
   return {};
}

export default connect(mapStateToProps, mapDispatchToProps)(Profile);